// OAuth2Login.js
import React, { useEffect } from 'react';


const OAuth2Login = () => {
    // const history = useHistory();

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Assuming authentication is successful



                // Navigate back to the previous window with success information
                window.opener.postMessage(getQueryVariable('code'), window.origin);
                window.close();
            } catch (e) {
                // Handle any exceptions
                console.error(e);
            }
        };

        fetchData();
    }, []);

    function getQueryVariable(variable) {
        const query = window.location.search.substring(1);
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (pair[0] === variable) {
                return pair[1];
            }
        }
        return false;
    }

    return (
      <div>
        <p style={{ color: 'white' }}>Authenticating...</p>
        {/* You can add a loading spinner or any other UI elements here */}
      </div>
    );
};

export default OAuth2Login;
